"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationV2 = void 0;
const react_1 = __importDefault(require("react"));
const NumberedPagination_1 = __importDefault(require("./NumberedPagination"));
const PaginationV2 = ({ continuous = false, count, hideNextPrevButtons = false, onPageChange, page, siblingCount, disabled = false }) => {
    const hasNext = page < count;
    const hasPrev = page > 1;
    const hideNextPrevButtonsArray = react_1.default.useMemo(() => {
        if (Array.isArray(hideNextPrevButtons)) {
            return hideNextPrevButtons;
        }
        else {
            return [hideNextPrevButtons, hideNextPrevButtons, hideNextPrevButtons];
        }
    }, [hideNextPrevButtons]);
    const handlePageChange = react_1.default.useCallback((pageNext) => {
        if (pageNext === page) {
            return;
        }
        else if (continuous) {
            if (pageNext < 1) {
                onPageChange(count, "back");
            }
            else if (pageNext > count) {
                onPageChange(1, "forward");
            }
            else {
                onPageChange(pageNext, pageNext > page ? "forward" : "back");
            }
        }
        else if (pageNext >= 1 && pageNext <= count) {
            onPageChange(pageNext, pageNext > page ? "forward" : "back");
        }
    }, [continuous, count, onPageChange, page]);
    const handleClickNext = react_1.default.useCallback(() => handlePageChange(page + 1), [handlePageChange, page]);
    const handleClickPrev = react_1.default.useCallback(() => handlePageChange(page - 1), [handlePageChange, page]);
    const handleKeyUp = react_1.default.useCallback((e) => {
        switch (e.key) {
            case "ArrowLeft":
                handleClickPrev();
                break;
            case "ArrowRight":
                handleClickNext();
                break;
        }
    }, [handleClickPrev, handleClickNext]);
    if (count <= 0) {
        return null;
    }
    const props = {
        continuous,
        count,
        handleClickNext,
        handleClickPrev,
        handleKeyUp,
        handlePageChange,
        hasNext,
        hasPrev,
        hideNextPrevButtonsArray,
        page,
        disabled
    };
    return (react_1.default.createElement(NumberedPagination_1.default, Object.assign({}, props, { siblingCount: siblingCount, disabled: disabled })));
};
exports.PaginationV2 = PaginationV2;
//# sourceMappingURL=Pagination.js.map